var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSemiDetached(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "145px",
    height: "76px",
    viewBox: "0 0 145 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 144.756 0 144.756 29.78875 0 29.78875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 75.883 144.756 75.883 144.756 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4977,27.4306 L9.4977,75.8826 L43.4707,75.8826 L62.2167,75.8826 L72.3957,75.8826 L72.3957,72.8286 L62.2167,72.8286 L62.2167,39.8516 L43.4707,39.8516 L43.4707,72.8286 L12.5537,72.8286 L12.5537,29.0926 L41.7117,10.2216 L71.5657,29.5436 L73.2257,26.9796 L41.7117,6.5826 L9.4977,27.4306 Z M46.5257,72.8276 L59.1627,72.8276 L59.1627,42.9066 L46.5257,42.9066 L46.5257,72.8276 Z",
    id: "Fill-1",
    fill: "#00614E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.835,54.779 L34.504,54.779 L34.504,42.906 L30.835,42.906 L30.835,54.779 Z M21.868,54.78 L27.779,54.78 L27.779,42.907 L21.868,42.907 L21.868,54.78 Z M18.814,57.834 L37.56,57.834 L37.56,39.851 L18.814,39.851 L18.814,57.834 Z",
    id: "Fill-2",
    fill: "#00614E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8318,27.4306 L70.8318,75.8826 L82.5388,75.8826 L101.2848,75.8826 L135.2578,75.8826 L135.2578,27.4306 L103.0448,6.5826 L70.8318,27.4306 Z M73.8878,29.0926 L103.0448,10.2216 L132.2028,29.0926 L132.2028,72.8286 L101.2848,72.8286 L101.2848,39.8516 L82.5388,39.8516 L82.5388,72.8286 L73.8878,72.8286 L73.8878,29.0926 Z M85.5938,72.8276 L98.2308,72.8276 L98.2308,42.9066 L85.5938,42.9066 L85.5938,72.8276 Z",
    id: "Fill-3",
    fill: "#00614E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 0.000450)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.1817,26.73375 L103.8747,7.11975 C103.3697,6.79375 102.7207,6.79375 102.2147,7.11975 L72.3777,26.42975 L42.5407,7.11975 C42.0357,6.79375 41.3867,6.79375 40.8807,7.11975 L10.5747,26.73375 L6.5817,26.73375 L41.7107,3.36275 L71.5147,23.19075 C72.0257,23.53175 72.6927,23.53175 73.2057,23.19175 L103.0437,3.36175 L138.1737,26.73375 L134.1817,26.73375 Z M18.2327,4.67075 L26.4237,4.67075 L26.4237,9.86375 L18.2327,15.31275 L18.2327,4.67075 Z M118.3317,4.67075 L126.5237,4.67075 L126.5237,15.31275 L118.3317,9.86375 L118.3317,4.67075 Z M144.0747,26.98975 L129.5697,17.33975 L129.5777,17.33975 L129.5777,1.61475 L115.2777,1.61475 L115.2777,7.83175 L103.8907,0.25575 C103.3787,-0.08525 102.7117,-0.08425 102.2007,0.25475 L72.3607,20.08475 L42.5567,0.25575 C42.0447,-0.08525 41.3767,-0.08525 40.8657,0.25575 L29.4787,7.83175 L29.4787,1.61475 L15.1777,1.61475 L15.1777,17.33975 L15.1867,17.33975 L0.6817,26.98975 C0.1207,27.36175 -0.1303,28.05875 0.0657,28.70375 C0.2607,29.34775 0.8547,29.78875 1.5277,29.78875 L11.0257,29.78875 C11.3207,29.78875 11.6077,29.70375 11.8557,29.54375 L41.7107,10.22175 L71.5657,29.54375 L72.3777,28.28875 L73.1907,29.54375 L103.0447,10.22175 L132.9007,29.54375 C133.1487,29.70375 133.4357,29.78875 133.7307,29.78875 L143.2287,29.78875 C143.9017,29.78875 144.4947,29.34775 144.6907,28.70375 C144.8857,28.05875 144.6347,27.36175 144.0747,26.98975 L144.0747,26.98975 Z",
    id: "Fill-4",
    fill: "#00614E",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.977,54.779 L122.888,54.779 L122.888,42.906 L116.977,42.906 L116.977,54.779 Z M110.252,54.78 L113.921,54.78 L113.921,42.907 L110.252,42.907 L110.252,54.78 Z M107.196,57.834 L125.942,57.834 L125.942,39.851 L107.196,39.851 L107.196,57.834 Z",
    id: "Fill-7",
    fill: "#00614E",
    mask: "url(#mask-4)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiDetached);
export default __webpack_public_path__ + "static/media/semi-detached.526076565b13e0267638a6de107fb8d4.svg";
export { ForwardRef as ReactComponent };